<template>
  <a-spin :tip="loadingTip" :spinning="isloading">
    <div>
      <div class>
        <a-form :form="form" @submit="handleSubmit">
          <a-form-item label="学员姓名" :label-col="{ span: 4 }" :wrapper-col="{ span: 10 }">
            <a-input
              placeholder="请输入学员姓名"
              readOnly
              v-decorator="[
          'title',
          {rules: [{ required: false, message: '请输入学员姓名!' }],initialValue:info.fullName}
        ]"
              :disabled="sta"
            ></a-input>
          </a-form-item>
          <a-form-item label="手机号码" :label-col="{ span: 4 }" :wrapper-col="{ span: 10 }">
            <a-input
              placeholder="请输入手机号码"
              readOnly
              v-decorator="[
          'telephone',
          {rules: [{ required: false, message: '请输入手机号码!' }],initialValue:info.telephone}
        ]"
              :disabled="sta"
            ></a-input>
          </a-form-item>
          <a-form-item label="身份证号" :label-col="{ span: 4 }" :wrapper-col="{ span: 10 }">
            <a-input
              placeholder="请输入身份证号"
              readOnly
              v-decorator="[
          'idCard',
          {rules: [{ required: false, message: '请输入身份证号!' }],initialValue:info.idCard}
        ]"
              :disabled="sta"
            ></a-input>
          </a-form-item>
          <a-form-item label="证书名称" :label-col="{ span: 4 }" :wrapper-col="{ span: 10 }">
            <a-input
              placeholder="请输入证书名称"
              readOnly
              v-decorator="[
          'creName',
          {rules: [{ required: false, message: '请输入证书名称!' }],initialValue:info.certificateName}
        ]"
              :disabled="sta"
            ></a-input>
          </a-form-item>
          <a-form-item label="年度" :label-col="{ span: 4 }" :wrapper-col="{ span: 10 }">
            <a-input
              placeholder="请输入年度"
              readOnly
              v-decorator="[
          'years',
          {rules: [{ required: false, message: '请输入年度!' }],initialValue:info.years}
        ]"
              :disabled="sta"
            ></a-input>
          </a-form-item>
          <a-form-item label="课程学习情况" :label-col="{ span: 4 }" :wrapper-col="{ span: 18 }">
            <a-table
              :columns="list.columns"
              rowKey="id"
              :pagination="false"
              :dataSource="info.list"
              :loading="isloading"
              :locale="{emptyText:'暂无数据'}"
            ></a-table>
          </a-form-item>

          <a-form-item label="审核记录" :label-col="{ span: 4 }" :wrapper-col="{ span: 18 }">
            <span>{{info.oldSuggest ? info.oldSuggest:"暂无历史"}}</span>
          </a-form-item>

          <div class="checkWrapper" v-if="type==1">
            <div class="inner">
              <a-form-item label="审核结果" :label-col="{ span: 4 }" :wrapper-col="{ span: 10 }">
                <a-radio-group
                  v-decorator="[
          'auditStatus',
          {rules: [{ required: true, message: '请选择审核结果!' }],initialValue:info.auditStatus}
        ]"
                >
                  <a-radio :value="1">通过</a-radio>
                  <a-radio :value="2">拒绝</a-radio>
                </a-radio-group>
              </a-form-item>
              <a-form-item label="审核意见" :label-col="{ span: 4 }" :wrapper-col="{ span: 10 }">
                <a-textarea
                  placeholder="请输入审核意见"
                  :rows="4"
                  v-decorator="[
          'auditOption',
          {rules: [{ required: false, message: '请输入审核意见!' }],initialValue:info.auditOption}
        ]"
                />
              </a-form-item>
            </div>
          </div>
          <a-form-item :wrapper-col="{ span: 18, offset: 4 }">
            <pxkeji-btn name="提交" v-if="this.type==1" type="primary" htmlType="submit" />
            <pxkeji-btn name="取消" type="default" @click="cancelClick" class="cancelBtn" />
          </a-form-item>
        </a-form>
      </div>
    </div>
  </a-spin>
</template>

<script>
var that;

const columns = [
  {
    dataIndex: "courseName",
    key: "courseName",
    align: "center",
    title: "课程名称",
  },
  {
    dataIndex: "classHours",
    key: "classHours",
    align: "center",
    title: "总学时",
  },
];

var thisInfo = [];
export default {
  props: {
    id: String,
    type: Number,
    dataZone:String
  },
  data() {
    return {
      form: this.$form.createForm(this),
      sta: true,
      list: {
        columns, //表头
        datas: [], //数据
      },
      info: {
        author: "",
        categoryId: [0],
        tag: "",
      },
      isloading: false,
      loadingTip: "加载中...",
    };
  },
  mounted() {
    this.$nextTick(function () {
      that = this;
      this.getInfo();
    });
  },
  methods: {
    /**取消 */
    cancelClick() {
      this.$emit("callbackMethod");
    },

    /**获取详情 */
    getInfo() {
      this.isloading = true;
      this.$api.certificate
        .getCertificateRecordDetail(
          this.id,this.dataZone
        )
        .then((res) => {
          this.isloading = false;
          if (res.errorCode == this.$msg.responseCode.success) {
            this.info = res.data;
          } else {
            this.error(res.errorMsg);
          }
        })
        .catch(() => {
          this.isloading = false;
        });
    },
    /**提交审核 */
    handleSubmit(e) {
      e.preventDefault();
      this.form.validateFields((err, values) => {
        if (!err) {
          //审核
          this.isloading = true;
          this.loadingTip = "审核中...";
          this.$api.certificate
            .auditApplyRecord(
              this.id,
              values.auditStatus,
              values.auditOption
            )
            .then((res) => {
              this.isloading = false;
              if (res.errorCode == this.$msg.responseCode.success) {
                this.$message.success(res.errorMsg);
                this.$emit("callbackMethod");
              } else {
                this.error(res.errorMsg);
              }
            })
            .catch(() => {
              this.isloading = false;
            });
        }
      });
    },

    error(msg) {
      this.$error({
        title: "提示",
        content: msg == undefined ? "服务器异常" : msg,
        okText: "返回",
        centered: true,
        onOk() {
          that.$emit("callbackMethod");
        },
      });
    },
  },
};
</script>
<style>
.checkWrapper {
  padding-top: 20px;
  border-top: 1px #d9d9d9 solid;
}
</style>